import { createContext, useContext, ReactNode } from "react";

interface DomainContextType {
    isPersonal: boolean;
    isPublic: boolean;
    showPersonalInfo: boolean;
}

const DomainContext = createContext<DomainContextType | undefined>(undefined);

export function DomainProvider({ children }: { children: ReactNode }) {
    const hostname = window.location.hostname;

    const isPersonal = hostname === 'arigoldman.dev' ||
                      hostname === 'www.arigoldman.dev' ||
                      hostname === 'localhost' ||
                      hostname.startsWith('10.0.0.')

    const isPublic = hostname === 'goobst.dev' ||
                    hostname === 'www.goobst.dev'

    // const isPersonal = false;
    // const isPublic = !isPersonal;

    return (
        <DomainContext.Provider
            value={{
                isPersonal,
                isPublic,
                showPersonalInfo: isPersonal,
            }}
        >
            {children}
        </DomainContext.Provider>
    );
}

export function useDomain() {
    const context = useContext(DomainContext);
    if (!context) {
        throw new Error("useDomain must be used within DomainProvider");
    }
    return context;
}
